<template>
  <div class="mt-2">
    <!-- Division: {{ currentDivision }} -->
    <div class="w-100 d-flex justify-content-center" v-if="loading">
      <div scope="row" style="width: 50vw; height: 2rem">
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 seed-table-full-component" v-else-if="!loading && this.seedTable?.length">
      <div class="col-11 d-flex justify-content-around title-table"
        :style="{ 'background-color': `#${selectedProductColor}` }">
        <div style="display: flex">
          <img class="icon-title" v-if="selectedProductIcon" :src="selectedProductIcon" alt="product icon" />
          <div class="p-2 text-center title-table-info">{{ this.selectedProduct && (this.selectedProduct).toUpperCase() }}
          </div>
          <div class="p-2 text-center title-table-info">--</div>
          <div class="p-2 text-center title-table-info">{{ parseFloat(this.divisionSize).toFixed(0) }} has.</div>
          <div class="p-2 text-center title-table-info">--</div>
          <div class="p-2 text-center title-table-info">(Potrero {{ this.currentDivision }})</div>
        </div>
      </div>
      <div class="w-100 d-flex justify-content-around table-border">
        <!-- Repeat table-info class instead of putting it on the Table head to prevent the empty cell to have a little background-color border -->
        <div class="col-2 p-1 p-2 text-center table-info table-info-first">Proveedor</div>
        <div class="col-3 p-1 p-2 text-center table-info ">Nombre</div>
        <div class="col-3 p-1 p-2 text-center table-info">Coste</div>
        <div class="col-3 p-1 p-2 text-center table-info">Rentabilidad</div>
        <div class="col-1 p-1 p-2 text-center" style="background-color: white; border: none"></div>
      </div>
      <div class="accordion" id="accordionExample">
        <SeedTableItem v-for="(seedData, i) in this.seedTable" :key="i" :seedData="seedData" :accordionNumber="Math.floor(Math.random() * 100000) * Math.floor(Math.random() * 100000) +
          Math.floor(Math.random() * 100000) * Math.floor(Math.random() * 100000) +
          Math.floor(Math.random() * 100000)
          " :divisionSize="this.divisionSize" />
      </div>
    </div>
    <!-- Error message if no seed type found -->
    <!-- <div class="w-100" v-else-if="this.seedTable?.length === 0">No se encontraron datos de semilla para este tipo de grano, seleccione otro.</div> -->
    <!-- Old messages, delete if not used anymore -->
    <div class="haga-click-sobre" v-else-if="this.seedTable?.length === 0">
     <span class="arrows-up">↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑</span><br>
      Click en Potrero {{ this.currentDivision }}
      para asignar semilla.</div>
    <div class="haga-click-sobre-else d-flex justify-content-around" v-else>
      <div class="col-8">Click en Potrero {{ this.currentDivision }} para asignar semilla.</div>   
      <div class="arrows-up col-4"> ↑ </div>   
    </div>
    <!-- <span class="arrows-up-else" v-else>↑ ↑</span> -->
  </div>
</template>

<script>
import SeedTableItem from "./SeedTableItem.vue";
export default {
  props: {
    seedTable: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    selectedProduct: {
      type: String,
    },
    selectedProductColor: {
      type: String,
    },
    selectedProductIcon: {
      type: String,
    },
    currentDivision: {
      type: Number,
    },
    divisionSize: {
      type: Number,
    },
    divisionId: Number,
  },
  watch: {
    seedTable: {
      handler(newVal) {

      },
      deep: true
    }
  },
  components: { SeedTableItem },
};
</script>
<style scoped>
.gray-background {
  background-color: #f0f0f0;
}

.accordion-button {
  background-color: white !important;
}

.accordion {
  --bs-accordion-btn-focus-border-color: none !important;
  --bs-accordion-btn-focus-box-shadow: none !important;
}

#yellowAccordionButton {
  background-color: #fdffd8 !important;
}


.yellow-bg-color {
  background-color: #fdffd8;
}

.table-border {
  border: 0;
}

.accordion {
  --bs-accordion-btn-icon: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m12.002 2c5.518 0 9.998 4.48 9.998 9.998 0 5.517-4.48 9.997-9.998 9.997-5.517 0-9.997-4.48-9.997-9.997 0-5.518 4.48-9.998 9.997-9.998zm0 1.5c-4.69 0-8.497 3.808-8.497 8.498s3.807 8.497 8.497 8.497 8.498-3.807 8.498-8.497-3.808-8.498-8.498-8.498zm-.747 7.75h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h3.5v3.5c0 .414.336.75.75.75s.75-.336.75-.75v-3.5h3.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-3.5v-3.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75z' fill-rule='nonzero'/%3E%3C/svg%3E");
  --bs-accordion-btn-icon-width: 1.75rem;
  --bs-accordion-btn-icon-transform: rotate(180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url("data:image/svg+xml,%3Csvg clip-rule='evenodd' fill-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m12.002 2.005c5.518 0 9.998 4.48 9.998 9.997 0 5.518-4.48 9.998-9.998 9.998-5.517 0-9.997-4.48-9.997-9.998 0-5.517 4.48-9.997 9.997-9.997zm0 1.5c-4.69 0-8.497 3.807-8.497 8.497s3.807 8.498 8.497 8.498 8.498-3.808 8.498-8.498-3.808-8.497-8.498-8.497zm4.253 7.75h-8.5c-.414 0-.75.336-.75.75s.336.75.75.75h8.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z' fill-rule='nonzero'/%3E%3C/svg%3E");
}

.title-table {
  height: 40px;
  border-top-left-radius: var(--main-border-radius);
  border-top-right-radius: var(--main-border-radius);
}

.icon-title {
  height: 36px;
  padding-top: 4px;
  padding-right: 4px;
}

.table-info {
  /* background-color: #EEEEEE;
  background-color: green; */
  background-color: var(--light-gray);
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.table-info-first {
  border-left: 1px solid black;
}

.seed-table-full-component {
  margin-top: 1.5rem;
}

.haga-click-sobre {
  width: 80%;
  margin-left: 5%;
  text-align: center; 
  font-weight: 700;
  /* font-size: 1.8rem; */
}

.arrows-up {
  width: 80%;
  font-weight: 700;
  color: red;
  font-size: 1.8rem;
  /* 
  text-align: center; */
}

.haga-click-sobre-else {
  width: 80%;
  margin-left: 5%;
  text-align: left; 
  font-weight: 700;
  padding-top: 0.4rem;
  /* font-size: 1.8rem; */
}

.click-haga-click-sobre-else {
  width: 40%;
}


/* @media screen and (max-width: 1000px) {
  * {
    font-size: 9px;
  }
} */


@media screen and (max-width: 700px) {
  .seed-table-full-component {
    width: 97vw !important;
    margin-left: 1vw;
  }

  .table-info {
    /* background-color: #EEEEEE;
  background-color: green; */
    background-color: var(--light-gray);
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.7rem;
  }

  .icon-title {
    height: 30px;
    align-items: center;
  }

  .title-table {
    align-items: center;
  }

  .title-table-info {
    font-size: 0.7rem;
  }

}
</style>
